import { useState, useEffect } from 'react';

export const useDragText = (initialPosition, onDragEnd) => {
    const [position, setPosition] = useState(initialPosition);
    const [isDragging, setIsDragging] = useState(false);
    const [offset, setOffset] = useState({ x: 0, y: 0 });

    const handleMouseDown = (e) => {
        e.preventDefault();
        setIsDragging(true);
        setOffset({
            x: e.clientX - position.x,
            y: e.clientY - position.y,
        });
    };

    useEffect(() => {
        if (!isDragging) return;

        const handleMouseMove = (e) => {
            setPosition({
                x: e.clientX - offset.x,
                y: e.clientY - offset.y,
            });
        };

        const handleMouseUp = () => {
            setIsDragging(false);
            if (onDragEnd) {
                onDragEnd(position);
            }
        };

        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);

        return () => {
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
        };
    }, [isDragging, offset, onDragEnd]);

    return {
        position,
        handleMouseDown,
        isDragging,
        dragStyles: {
            cursor: isDragging ? 'grabbing' : 'grab',
            opacity: isDragging ? 0.8 : 1,
            outline: isDragging ? '2px solid #1890ff' : 'none'
        }
    };
};